import axios from 'axios'
import { ICrudDeleteAction, ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudSearchAction } from 'react-jhipster'

import { cleanEntity } from '../../../utils/entity-utils'
import { FAILURE, REQUEST, SUCCESS } from '../action-type.util'

import { defaultValue, IPlayerCategory } from '../../model/player-category.model'

export const ACTION_TYPES = {
  SEARCH_PLAYERCATEGORIES: 'playerCategory/SEARCH_PLAYERCATEGORIES',
  FETCH_PLAYERCATEGORY_LIST: 'playerCategory/FETCH_PLAYERCATEGORY_LIST',
  FETCH_PLAYERCATEGORY: 'playerCategory/FETCH_PLAYERCATEGORY',
  CREATE_PLAYERCATEGORY: 'playerCategory/CREATE_PLAYERCATEGORY',
  UPDATE_PLAYERCATEGORY: 'playerCategory/UPDATE_PLAYERCATEGORY',
  DELETE_PLAYERCATEGORY: 'playerCategory/DELETE_PLAYERCATEGORY',
  RESET: 'playerCategory/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IPlayerCategory>,
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};

export type PlayerCategoryState = Readonly<typeof initialState>;

// Reducer

export default (state: PlayerCategoryState = initialState, action): PlayerCategoryState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.SEARCH_PLAYERCATEGORIES):
    case REQUEST(ACTION_TYPES.FETCH_PLAYERCATEGORY_LIST):
    case REQUEST(ACTION_TYPES.FETCH_PLAYERCATEGORY):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_PLAYERCATEGORY):
    case REQUEST(ACTION_TYPES.UPDATE_PLAYERCATEGORY):
    case REQUEST(ACTION_TYPES.DELETE_PLAYERCATEGORY):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.SEARCH_PLAYERCATEGORIES):
    case FAILURE(ACTION_TYPES.FETCH_PLAYERCATEGORY_LIST):
    case FAILURE(ACTION_TYPES.FETCH_PLAYERCATEGORY):
    case FAILURE(ACTION_TYPES.CREATE_PLAYERCATEGORY):
    case FAILURE(ACTION_TYPES.UPDATE_PLAYERCATEGORY):
    case FAILURE(ACTION_TYPES.DELETE_PLAYERCATEGORY):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.SEARCH_PLAYERCATEGORIES):
    case SUCCESS(ACTION_TYPES.FETCH_PLAYERCATEGORY_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
        totalItems: parseInt(action.payload.headers['x-total-count'], 10),
      };
    case SUCCESS(ACTION_TYPES.FETCH_PLAYERCATEGORY):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_PLAYERCATEGORY):
    case SUCCESS(ACTION_TYPES.UPDATE_PLAYERCATEGORY):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_PLAYERCATEGORY):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

const apiUrl = 'api/player-categories';
const apiSearchUrl = 'api/_search/player-categories';

// Actions

export const getSearchEntities: ICrudSearchAction<IPlayerCategory> = (query, page, size, sort) => ({
  type: ACTION_TYPES.SEARCH_PLAYERCATEGORIES,
  payload: axios.get<IPlayerCategory>(`${apiSearchUrl}?query=${query}${sort ? `&page=${page}&size=${size}&sort=${sort}` : ''}`),
});

export const getEntities: ICrudGetAllAction<IPlayerCategory> = (page, size, sort) => {
  const requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}`;
  return {
    type: ACTION_TYPES.FETCH_PLAYERCATEGORY_LIST,
    payload: axios.get<IPlayerCategory>(`${requestUrl}${sort ? '&' : '?'}cacheBuster=${new Date().getTime()}`),
  };
};

export const getEntity: ICrudGetAction<IPlayerCategory> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_PLAYERCATEGORY,
    payload: axios.get<IPlayerCategory>(requestUrl),
  };
};

export const createEntity: ICrudPutAction<IPlayerCategory> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_PLAYERCATEGORY,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IPlayerCategory> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_PLAYERCATEGORY,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const deleteEntity: ICrudDeleteAction<IPlayerCategory> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_PLAYERCATEGORY,
    payload: axios.delete(requestUrl),
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
